export default __webpack_public_path__ + "static/media/ALUMNI1.3eee8048.jpg";